enum Environment {
  qa = 'qa',
  staging = 'staging',
  production = 'production',
}

const GroundcoverConfig = () => {
  const appId = window.location.hostname
  const env = window.location.hostname.includes('app.pcd.platform9.com')
    ? Environment.production
    : window.location.hostname.includes('app.staging-pcd.platform9.com')
    ? Environment.staging
    : Environment.qa

  const config = {
    [Environment.qa]: {
      apiKey: 'gcik_AEBAAABY_YJI3DSFI_ISK2KYWA_IAPMDW3H',
      cluster: 'ops-opex-pcd-qa',
      environment: 'ops-opex-pcd-qa',
      dsn: 'https://p8n0cu.platform.grcv.io',
      appId,
    },
    [Environment.staging]: {
      apiKey: 'gcik_AEBAAAFV_BIKTG3W6_JYK2VUJW_3AU6YW46',
      cluster: 'ops-opex-pcd-staging',
      environment: 'ops-opex-pcd-staging',
      dsn: 'https://p8n0cu.platform.grcv.io',
      appId,
    },
    [Environment.production]: {
      apiKey: 'gcik_AEBAAADJ_R3LNE2PJ_JM7IORT6_CF2FISCV',
      cluster: 'ops-cogs-pcd-prod',
      environment: 'ops-cogs-pcd-prod',
      dsn: 'https://p8n0cu.platform.grcv.io',
      appId,
    },
  }

  return config[env]
}

export default GroundcoverConfig
